import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import classnames from 'classnames';

import EventDetail from './EventDetail';
import styles from './DndSection.scss';


function DndSection(props) {
    const [items, setItems] = useImmer([]);

    useEffect(() => {
        setItems(() => {
            return props.items;
        });
    }, [props.items]);

    function onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const newItems = reorder(
            items,
            result.source.index,
            result.destination.index
        );

        setItems(() => {
            return newItems;
        });

        props.onItemOrderChanged(newItems);
    }

    function reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    return (
        <DragDropContext onDragEnd={onDragEnd} data-cy="DndSection-onDragEnd">
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className={classnames(styles.list, { [styles.listIsDragging]: snapshot.isDraggingOver })}
                        data-cy="DndSection-div"
                    >
                        {items.map((item, index) => (
                            <Draggable key={item.id} draggableId={item.id} index={index} data-cy={'DndSection-' + index}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={classnames(styles.item, { [styles.itemIsDragging]: snapshot.isDragging })}
                                    >
                                        <EventDetail
                                            key={`dnd-event-detail-${item.id}`}
                                            view={props.view}
                                            detail={item}
                                            dataSources={props.dataSources}
                                            onRemoveItem={() => props.onRemoveItem(item.id)}
                                            onItemChanged={props.onItemChanged}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default DndSection;
